export default{
	phone:{
		chinese:{
			banner:require('@/images/mobile/zoology/1-0.png'),
			slidingList: ["供应链金融发展史", "供应链金融角色", "行业资讯"], 
			//供应链发展历程
			development:{
				title:'供应链金融发展历程',
				courseList: [
				  {
				    //发展历程数组
				    title: "不动产抵押、信用评级",
				    desc:
				      "银行基于核心企业“1”的信用为供应链上的“N”个企业提供融资服务，采用线下“1+N”模式提高各企业间协同化运作能力。",
				    circle: "1.0",
				    tedian: "供应链金融1.0",
				    pingtai: "中心化"
				  },
				  {
				    title: "互联网科技、动产质押",
				    desc:
				      "互联网技术初步运用，使物流、信息流和资金流一体化、线上化， “1+N”模式演变为线上版本，通过信息化降低融资风险。",
				    circle: "2.0",
				    tedian: "供应链金融2.0",
				    pingtai: "线上化"
				  },
				  {
				    title: "云计算、数据风控",
				    desc:
				      "打造综合性供应链服务平台代替核心企业“1”，解决信息不对称、配置缺位等问题。",
				    circle: "3.0",
				    tedian: "供应链金融3.0",
				    pingtai: "平台化"
				  },
				  {
				    title: "区块链技术、人工智能、大数据、物联网技术",
				    desc:
				      "供应链金融业务模式趋向于实时、定制、小额化，借助人工智能、区块链等技术实现信息全集成与共享。",
				    circle: "4.0",
				    tedian: "供应链金融4.0",
				    pingtai: "智慧化"
				  },
				  {
				    title: "未来",
				    desc:
				      "深入产业供应链场景，优化产业生态与金融生态融合；利用前沿科技与数字化手段，建设更快捷、更安全、更可信的供应链金融科技平台。",
				    circle: "未来",
				    tedian: "供应链金融未来",
				    pingtai: ""
				  }
				],
			},
			//供应链金融角色
			role:{
				title:'供应链金融角色',
				roleList: [
				  {
				    title: "核心企业",
				    img: require("@/images/zoology/4-9.png"),
				    tit: "传递信用价值，乐享供应链金融发展红利",
				    txt1:
				      "解决传统供应链金融产品无法触及2-N级中小微企业融资难的问题，提高融资服务覆盖度。",
				    txt2:
				      "促进企业销售增长、增加财务收益、降低产业链融资成本，提高供应链整体竞争力。",
				    txt3:
				      "供应链金融业务线上办理，依托高水平的数字化平台及7*24小时业务服务，平均放款时间仅约20分钟，便捷高效。",
				    txt4:
				      "复用金融机构出资功能，改善现金流，降低有息负债，支持ABS、再保理等业务盘活企业资产。"
				  },
				  {
				    title: "链属企业",
				    img: require("@/images/zoology/4-11.png"),
				    tit: "传递普惠政策，信用贷款保障资金需求",
				    desc: "(供应商)",
				    txt1: "解决传统供应链金融产品融资难、融资贵、融资慢等问题。",
				    txt2: "依托高水平业务团队，提供针对企业的定制化金融模式定制服务。",
				    txt3: "金融产品多样化，可按需拆分，灵活融资，合理管理资金收支平衡。",
				    txt4: ""
				  },
				  {
				    title: "金融机构",
				    img: require("@/images/zoology/4-12.png"),
				    tit: "互利共赢，服务产业",
				    desc: "(资金方)",
				    txt1:
				      "简单汇平台引流，单点接入、快速获客，降低营销成本，易于接触潜在客户。",
				    txt2:
				      "借由平台协助进行贷前筛查，贷后预警，对称共享企业授信数据及实际经营信息，降低风控难度。",
				    txt3:
				      "平台业务操作方便，简单高效，减少传统业务模式下资金方交易手续繁琐、花费时间长、运营成本高等问题，实现服务普惠，互利共赢。",
				    txt4: ""
				  },
				  {
				    title: "平台方",
				    img: require("@/images/zoology/4-13.png"),
				    tit: "科技引领行业发展，信息传递产融价值",
				    txt1: "为链上主体提供互动平台，加强上下游企业联动。",
				    txt2: "传递交易信息、呈现流程操作过程，降低风险控制成本。",
				    txt3: "",
				    txt4: ""
				  }
				],
			},
			//行业资讯
			information:{
				title:'行业资讯',
				more:'加载更多',
				detail:{
					title:'新闻导览',
					returnList:'返回列表'
				}
			}
		},
		english:{
			banner:require('@/images/mobile/english/banner_zoology.png'),
			slidingListYW: [
			  "Development of supply chain finance",
			  "The role of supply chain finance"
			],
			//供应链发展历程
			development:{
				title:'Development of supply chain finance',
				courseListYW: [
				  {
				    //发展历程数组
				    title: "Real estate mortgage, credit rating",
				    desc:
				      "Banks provide financing services for “N” enterprises in the supply chain based on the credit of the core enterprise “1”, and adopt the offline “1 + N” mode to improve the collaborative operation ability among enterprises.",
				    circle: "1.0",
				    tedian: "Supply Chain Finance 1.0",
				    pingtai: "Centralization"
				  },
				  {
				    title: "Internet technology, chattel mortgage",
				    desc:
				      "Logistics, information flow and capital flow are integrated and becoming online with the initial application of Internet technology, the “1 + N” mode has turned into an online version, and the financing risks are reduced through informatization.",
				    circle: "2.0",
				    tedian: "Supply Chain Finance 2.0",
				    pingtai: "Online"
				  },
				  {
				    title: "Cloud computing, data risk control",
				    desc:
				      "A comprehensive supply chain service platform is created to replace the core enterprise “1”, thus solving the problems of information asymmetry, lack of configuration, etc.",
				    circle: "3.0",
				    tedian: "Supply Chain Finance 3.0",
				    pingtai: "Platform"
				  },
				  {
				    title:
				      "Blockchain technology, artificial intelligence (AI), big data, Internet of Things (IoT) technology",
				    desc:
				      "The supply chain finance business model tends to be real-time, customized and small-scale, and information integration and sharing are realized through technologies such as AI and blockchains",
				    circle: "4.0",
				    tedian: "Supply Chain Finance 4.0",
				    pingtai: "Intellectualization"
				  },
				  {
				    title: "Future",
				    desc:
				      "The industrial supply chain scenario is deeply explored and the integration of industrial ecology and financial ecology is optimized. The cutting-edge technology and digital means are used to build a faster, safer and more credible supply chain financial technology platform.",
				    circle: "Future",
				    tedian: "Future of Supply Chain Finance",
				    pingtai: ""
				  }
				],
			},
			//供应链金融角色
			role:{
				title:'The role of supply chain finance',
				roleListYW: [
				  {
				    title: "Core enterprise",
				    img: require("@/images/zoology/4-9.png"),
				    tit:
				      "Convey the credit value, enjoy the development dividend of supply chain finance",
				    txt1:
				      "Solve the problem that traditional supply chain financial products cannot offer solutions to financing difficulties faced by 2-N-level MSMEs, and improve the coverage of financing services.",
				    txt2:
				      "Promote the sales growth of enterprises, increase financial incomes, reduce the financing costs of the industrial chain, and improve the overall competitiveness of the supply chain.",
				    txt3:
				      "The supply chain finance business is handled online by virtue of the high-level digital platform and 7*24 business services and the average lending time is only about 20 minutes, contributing to convenience and efficiency.",
				    txt4:
				      "Reuse the investment function of financial institutions, improve the cash flow, reduce interest-bearing liabilities, and revitalize enterprise assets through businesses such as ABS and re-factoring."
				  },
				  {
				    title: "Chain enterprise",
				    img: require("@/images/zoology/4-11.png"),
				    tit:
				      "Launch inclusive policies, guarantee the capital demand through credit loans",
				    desc: "(supplier)",
				    txt1:
				      "Solve the problems of difficult, expensive and slow financing of financial products in the traditional supply chain.",
				    txt2:
				      "Rely on the high-level business team to provide customized financial model services for enterprises.",
				    txt3:
				      "Diversified financial products can be split on demand and flexibly financed, and income and expenditure should be reasonably balanced.",
				    txt4: ""
				  },
				  {
				    title: "Financial institution",
				    img: require("@/images/zoology/4-12.png"),
				    tit: "Work for mutual benefit and facilitate the industry",
				    desc: "(funder)",
				    txt1:
				      "JDH, featured by cash flow attraction, single-point access, and quick customer acquisition, reduces the marketing costs and contacts potential customers.",
				    txt2:
				      "The JDH platform assists in pre-loan screening and post-loan early warning, and shares enterprise credit data and actual business information, thus reducing the difficulty of risk control.",
				    txt3:
				      "It is convenient, simple and efficient to operate the business on the JDH platform, which reduces the problems of cumbersome and time-consuming transaction procedures, and high operating costs for the funder under the traditional business model, thereby realizing universal services and mutual benefits.",
				    txt4: ""
				  },
				  {
				    title: "Platform",
				    img: require("@/images/zoology/4-13.png"),
				    tit:
				      "Technology leads the development of the industry, and information delivers the value of industry and finance",
				    txt1:
				      "Provide an interactive platform for the main body in the supply chain and strengthen the linkage between upstream and downstream enterprises.",
				    txt2:
				      "Transmit transaction information, present the operation process, and reduce risk control costs.",
				    txt3: "",
				    txt4: ""
				  }
				],
			},
			//行业资讯
			information:{
				title:'Industry Information',
				more:'More',
				detail:{
					title:'Press the navigation',
					returnList:'Returns a list of'
				}
			}
			
		}
	},
	pc:{
		chinese:{
			banner:require('@/images/zoology/4-1.png'),
			slidingList: ["供应链金融发展史", "供应链金融角色", "行业资讯"], 
			//供应链发展历程
			development:{
				title:'供应链金融发展历程',
				courseList: [
				  {
				    //发展历程数组
				    title: "不动产抵押、信用评级",
				    desc:
				      "银行基于核心企业“1”的信用为供应链上的“N”个企业提供融资服务，采用线下“1+N”模式提高各企业间协同化运作能力。",
				    circle: "1.0",
				    tedian: "供应链金融1.0",
				    pingtai: "中心化"
				  },
				  {
				    title: "互联网科技、动产质押",
				    desc:
				      "互联网技术初步运用，使物流、信息流和资金流一体化、线上化， “1+N”模式演变为线上版本，通过信息化降低融资风险。",
				    circle: "2.0",
				    tedian: "供应链金融2.0",
				    pingtai: "线上化"
				  },
				  {
				    title: "云计算、数据风控",
				    desc:
				      "打造综合性供应链服务平台代替核心企业“1”，解决信息不对称、配置缺位等问题。",
				    circle: "3.0",
				    tedian: "供应链金融3.0",
				    pingtai: "平台化"
				  },
				  {
				    title: "区块链技术、人工智能、大数据、物联网技术",
				    desc:
				      "供应链金融业务模式趋向于实时、定制、小额化，借助人工智能、区块链等技术实现信息全集成与共享。",
				    circle: "4.0",
				    tedian: "供应链金融4.0",
				    pingtai: "智慧化"
				  },
				  {
				    title: "未来",
				    desc:
				      "深入产业供应链场景，优化产业生态与金融生态融合；利用前沿科技与数字化手段，建设更快捷、更安全、更可信的供应链金融科技平台。",
				    circle: "未来",
				    tedian: "供应链金融未来",
				    pingtai: ""
				  }
				],
			},
			//供应链金融角色
			role:{
				title:'供应链金融角色',
				roleList: [
				  {
				    title: "核心企业",
				    img: require("@/images/zoology/4-9.png"),
				    tit: "传递信用价值，乐享供应链金融发展红利",
				    txt1:
				      "解决传统供应链金融产品无法触及2-N级中小微企业融资难的问题，提高融资服务覆盖度。",
				    txt2:
				      "促进企业销售增长、增加财务收益、降低产业链融资成本，提高供应链整体竞争力。",
				    txt3:
				      "供应链金融业务线上办理，依托高水平的数字化平台及7*24小时业务服务，平均放款时间仅约20分钟，便捷高效。",
				    txt4:
				      "复用金融机构出资功能，改善现金流，降低有息负债，支持ABS、再保理等业务盘活企业资产。"
				  },
				  {
				    title: "链属企业",
				    img: require("@/images/zoology/4-11.png"),
				    tit: "传递普惠政策，信用贷款保障资金需求",
				    desc: "(供应商)",
				    txt1: "解决传统供应链金融产品融资难、融资贵、融资慢等问题。",
				    txt2: "依托高水平业务团队，提供针对企业的定制化金融模式定制服务。",
				    txt3: "金融产品多样化，可按需拆分，灵活融资，合理管理资金收支平衡。",
				    txt4: ""
				  },
				  {
				    title: "金融机构",
				    img: require("@/images/zoology/4-12.png"),
				    tit: "互利共赢，服务产业",
				    desc: "(资金方)",
				    txt1:
				      "简单汇平台引流，单点接入、快速获客，降低营销成本，易于接触潜在客户。",
				    txt2:
				      "借由平台协助进行贷前筛查，贷后预警，对称共享企业授信数据及实际经营信息，降低风控难度。",
				    txt3:
				      "平台业务操作方便，简单高效，减少传统业务模式下资金方交易手续繁琐、花费时间长、运营成本高等问题，实现服务普惠，互利共赢。",
				    txt4: ""
				  },
				  {
				    title: "平台方",
				    img: require("@/images/zoology/4-13.png"),
				    tit: "科技引领行业发展，信息传递产融价值",
				    txt1: "为链上主体提供互动平台，加强上下游企业联动。",
				    txt2: "传递交易信息、呈现流程操作过程，降低风险控制成本。",
				    txt3: "",
				    txt4: ""
				  }
				],
			},
			//行业资讯
			information:{
				title:'行业资讯',
				more:'加载更多',
				detail:{
					title:'新闻导览',
					returnList:'返回列表'
				}
			}
		},
		english:{
			banner:require('@/images/english/banner_zoology.png'),
			slidingListYW: [
			  "Development of supply chain finance",
			  "The role of supply chain finance"
			],
			//供应链发展历程
			development:{
				title:'Development of supply chain finance',
				courseListYW: [
				  {
				    //发展历程数组
				    title: "Real estate mortgage, credit rating",
				    desc:
				      "Banks provide financing services for “N” enterprises in the supply chain based on the credit of the core enterprise “1”, and adopt the offline “1 + N” mode to improve the collaborative operation ability among enterprises.",
				    circle: "1.0",
				    tedian: "Supply Chain Finance 1.0",
				    pingtai: "Centralization"
				  },
				  {
				    title: "Internet technology, chattel mortgage",
				    desc:
				      "Logistics, information flow and capital flow are integrated and becoming online with the initial application of Internet technology, the “1 + N” mode has turned into an online version, and the financing risks are reduced through informatization.",
				    circle: "2.0",
				    tedian: "Supply Chain Finance 2.0",
				    pingtai: "Online"
				  },
				  {
				    title: "Cloud computing, data risk control",
				    desc:
				      "A comprehensive supply chain service platform is created to replace the core enterprise “1”, thus solving the problems of information asymmetry, lack of configuration, etc.",
				    circle: "3.0",
				    tedian: "Supply Chain Finance 3.0",
				    pingtai: "Platform"
				  },
				  {
				    title:
				      "Blockchain technology, artificial intelligence (AI), big data, Internet of Things (IoT) technology",
				    desc:
				      "The supply chain finance business model tends to be real-time, customized and small-scale, and information integration and sharing are realized through technologies such as AI and blockchains",
				    circle: "4.0",
				    tedian: "Supply Chain Finance 4.0",
				    pingtai: "Intellectualization"
				  },
				  {
				    title: "Future",
				    desc:
				      "The industrial supply chain scenario is deeply explored and the integration of industrial ecology and financial ecology is optimized. The cutting-edge technology and digital means are used to build a faster, safer and more credible supply chain financial technology platform.",
				    circle: "Future",
				    tedian: "Future of Supply Chain Finance",
				    pingtai: ""
				  }
				],
			},
			//供应链金融角色
			role:{
				title:'The role of supply chain finance',
				roleListYW: [
				  {
				    title: "Core enterprise",
				    img: require("@/images/zoology/4-9.png"),
				    tit:
				      "Convey the credit value, enjoy the development dividend of supply chain finance",
				    txt1:
				      "Solve the problem that traditional supply chain financial products cannot offer solutions to financing difficulties faced by 2-N-level MSMEs, and improve the coverage of financing services.",
				    txt2:
				      "Promote the sales growth of enterprises, increase financial incomes, reduce the financing costs of the industrial chain, and improve the overall competitiveness of the supply chain.",
				    txt3:
				      "The supply chain finance business is handled online by virtue of the high-level digital platform and 7*24 business services and the average lending time is only about 20 minutes, contributing to convenience and efficiency.",
				    txt4:
				      "Reuse the investment function of financial institutions, improve the cash flow, reduce interest-bearing liabilities, and revitalize enterprise assets through businesses such as ABS and re-factoring."
				  },
				  {
				    title: "Chain enterprise",
				    img: require("@/images/zoology/4-11.png"),
				    tit:
				      "Launch inclusive policies, guarantee the capital demand through credit loans",
				    desc: "(supplier)",
				    txt1:
				      "Solve the problems of difficult, expensive and slow financing of financial products in the traditional supply chain.",
				    txt2:
				      "Rely on the high-level business team to provide customized financial model services for enterprises.",
				    txt3:
				      "Diversified financial products can be split on demand and flexibly financed, and income and expenditure should be reasonably balanced.",
				    txt4: ""
				  },
				  {
				    title: "Financial institution",
				    img: require("@/images/zoology/4-12.png"),
				    tit: "Work for mutual benefit and facilitate the industry",
				    desc: "(funder)",
				    txt1:
				      "JDH, featured by cash flow attraction, single-point access, and quick customer acquisition, reduces the marketing costs and contacts potential customers.",
				    txt2:
				      "The JDH platform assists in pre-loan screening and post-loan early warning, and shares enterprise credit data and actual business information, thus reducing the difficulty of risk control.",
				    txt3:
				      "It is convenient, simple and efficient to operate the business on the JDH platform, which reduces the problems of cumbersome and time-consuming transaction procedures, and high operating costs for the funder under the traditional business model, thereby realizing universal services and mutual benefits.",
				    txt4: ""
				  },
				  {
				    title: "Platform",
				    img: require("@/images/zoology/4-13.png"),
				    tit:
				      "Technology leads the development of the industry, and information delivers the value of industry and finance",
				    txt1:
				      "Provide an interactive platform for the main body in the supply chain and strengthen the linkage between upstream and downstream enterprises.",
				    txt2:
				      "Transmit transaction information, present the operation process, and reduce risk control costs.",
				    txt3: "",
				    txt4: ""
				  }
				],
			},
			//行业资讯
			information:{
				title:'Industry Information',
				more:'More',
				detail:{
					title:'Press the navigation',
					returnList:'Returns a list of'
				}
			}
			
		}
	}
}


// WEBPACK FOOTER //
// ./src/utils/lang/zoology.js